// client/src/components/react-dashboard/organization/tabs/Overview.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Typography,
    Grid,
    Paper,
    Card,
    CardContent,
    CardActions,
    Button
} from "@mui/material";
import { PeopleOutline, StorageOutlined } from "@mui/icons-material";
import { useGetUsersByOrganizationIdQuery } from '../../../../features/users/usersApiSlice';
import { useGetAtgsByOrgIdQuery } from '../../../../features/atgs/atgsApiSlice';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ConnectAtgDialog from '../../global/ConnectAtgDialog';

const Overview = ({ organization }) => {
    const navigate = useNavigate();
    const [setupOpen, setSetupOpen] = useState(false);

    const handleNavigate = (path) => {
        navigate(path);
    };

    const {
        data: atgs,
        isLoading: isAtgsLoading,
        isError: isAtgsError
    } = useGetAtgsByOrgIdQuery(organization.organization_id);
    const { data: users, isLoading, isError } = useGetUsersByOrganizationIdQuery(organization.organization_id);

    const userCount = isLoading ? 'Loading...' : isError ? 'Error loading users' : `${users?.length || 0}`;
    const totalUserLimit = organization?.subscription?.userSeats || 1;


    return (
        <>
            <Grid container spacing={2} style={{ padding: '20px' }}>
                {/* General Info Section */}
                <Grid item xs={12}>
                    <Paper style={{ padding: '20px' }}>
                        <Typography variant="h5">{organization.name}</Typography>
                        <Typography variant="body1">Address: {organization.address}</Typography>
                        <Typography variant="body1">Phone: {organization.phone}</Typography>
                        <Typography variant="body1">Email: {organization.email}</Typography>
                        <Typography variant="body1">Type: {organization.type}</Typography>
                    </Paper>
                </Grid>

                {/* Stats Tiles */}
                <Grid item xs={12} sm={6}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6">
                                <PeopleOutline /> Users
                            </Typography>
                            <Typography variant="body1">{`${userCount}/${totalUserLimit} Users for the org`}</Typography>
                        </CardContent>
                        <CardActions>
                            <Button size="small" onClick={() => handleNavigate('/users')}>
                                View Users
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Card sx={{ height: '100%' }}>
                        <CardContent>
                            <Typography variant="h6">
                                <StorageOutlined /> Connected ATGs
                            </Typography>

                            <Typography variant="body1">
                                {isAtgsLoading
                                    ? 'Loading...'
                                    : isAtgsError
                                        ? 'Unable to load ATGs'
                                        : `${atgs?.length || 0} Connected ATG(s)`
                                }
                            </Typography>

                            {!isAtgsLoading && !isAtgsError && atgs?.length === 0 && (
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{ mt: 1 }}
                                >
                                    Connect your first ATG Pro to begin receiving tank
                                    inventory and compliance data.
                                </Typography>
                            )}
                        </CardContent>

                        <CardActions>
                            <Button
                                size="small"
                                onClick={() => handleNavigate('/atgs')}
                            >
                                View ATGs
                            </Button>

                            <Button
                                size="small"
                                startIcon={<AddCircleOutlineIcon />}
                                onClick={() => setSetupOpen(true)}
                            >
                                {atgs?.length
                                    ? 'Connect Another'
                                    : 'Connect ATG'
                                }
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>
                <ConnectAtgDialog
                    open={setupOpen}
                    onClose={() => setSetupOpen(false)}
                    organizationId={organization.organization_id}
                />
            </Grid>
        </>
    )
}

export default Overview;
